import React, {useEffect, useState } from 'react';
import UploadDocumentDirect from "components/common/upload/UploadDocumentDirect";
import DocumentAttachment from "components/common/upload/DocumentAttachment";
import { toast } from 'react-toastify';
import { updateCustomer, uploadKycDocument, removeKycDocument } from 'redux/crm/customerSlice';
import { useDispatch, useSelector } from 'react-redux';
import { CRM_KYC_CHECKLIST } from 'app_config';

const KycCheckList = () => {
  const [selected, setSelected] = useState(null);

  const {recordData: customer} = useSelector(state => state.crm_customer);
  const dispatch = useDispatch();

  const documents = customer?.kyc_documents || [];
  const {
    allow_view_kyc_document,
    allow_upload_kyc_document,
    allow_remove_kyc_document
  } = customer?.permissions || {}

  useEffect(() => {
    setSelected(customer?.kyc_type);
  }, [customer?.kyc_type]);

  const handleUploadDocument = (data) => {
    try {
      dispatch(uploadKycDocument({
        customerId: customer.id,
        data
      }))
    }
    catch(error) {
      toast.error(error.message)
    }
  }

  const handleRemoveDocument = (documentId) => {
    dispatch(removeKycDocument({
      customerId: customer.id,
      documentId
    }))
  }

  const handleUpdate = (value) => {
    try {
      setSelected(value);

      dispatch(updateCustomer({
        customerId: customer.id,
        formData: {kyc_type: value}
      }))
    }
    catch(error) {
      toast.error(error.message)
    }
  }

  return (
    <div className="tw-bg-white tw-rounded-lg tw-border tw-border-solid tw-border-slate-200 tw-shadow-sm tw-p-5">
      <div className="tw-mb-5">
        <h5 className="tw-text-base tw-font-bold tw-text-slate-900 tw-mb-0.5">KYC Checklist</h5>
        <p className="tw-text-sm tw-text-slate-500 tw-mb-0">Do you know your customer?</p>
      </div>

      <div className="tw-grid tw-grid-cols-12 tw-gap-6">
        {/* Left — checklist */}
        <div className="tw-col-span-12 md:tw-col-span-5">
          <div className="tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-400 tw-mb-2">
            Document type
          </div>
          <div className="tw-flex tw-flex-col tw-gap-2">
            {CRM_KYC_CHECKLIST.map((option, index) => {
              const isActive = selected === option;
              return (
                <label
                  key={option}
                  htmlFor={`${option}${index}`}
                  className={`tw-flex tw-items-center tw-gap-2.5 tw-px-3 tw-py-2.5 tw-rounded tw-border tw-border-solid tw-text-sm tw-transition-colors ${
                    allow_upload_kyc_document ? 'tw-cursor-pointer' : 'tw-cursor-default'
                  } ${
                    isActive
                      ? 'tw-border-blue-300 tw-bg-blue-50 tw-text-blue-800 tw-font-semibold'
                      : 'tw-border-slate-200 tw-bg-white tw-text-slate-700 hover:tw-bg-slate-50'
                  }`}
                >
                  <input
                    type="radio"
                    id={`${option}${index}`}
                    value={option}
                    className="tw-cursor-pointer tw-accent-blue-600"
                    checked={isActive}
                    onChange={() => allow_upload_kyc_document && handleUpdate(option)}
                    onClick={(e) => {
                      if (!allow_upload_kyc_document) {
                        e.preventDefault();
                      }
                    }}
                  />
                  {option}
                </label>
              );
            })}
          </div>
        </div>

        {/* Right — upload + attachments */}
        <div className="tw-col-span-12 md:tw-col-span-7">
          {allow_upload_kyc_document && (
            <UploadDocumentDirect uploadDocument={(data) => handleUploadDocument(data)} />
          )}

          <div className="tw-mt-4">
            <div className="tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-400 tw-mb-2">
              Attachments{documents.length > 0 ? ` (${documents.length})` : ''}
            </div>
            {documents && documents.length > 0 ? (
              <div className="tw-flex tw-flex-col tw-gap-2">
                {documents.map(attachment => (
                  <DocumentAttachment
                    {...attachment}
                    key={attachment.id}
                    isTable
                    allowView={allow_view_kyc_document}
                    allowRemove={allow_remove_kyc_document}
                    allowDownload={allow_view_kyc_document}
                    handleRemoveAttachment={(documentId) => handleRemoveDocument(documentId)}
                  />
                ))}
              </div>
            ) : (
              <div className="tw-text-sm tw-text-slate-400 tw-py-6 tw-text-center tw-border tw-border-dashed tw-border-slate-200 tw-rounded">
                No documents uploaded yet
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default KycCheckList;
